import { createAxiosInstance } from '~/plugins/axios.plugin';

class SafeAService {
  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.SAFEA_API,
      useAccessToken : true,
      customHeaders  : { 'Cache-Control': 'no-cache' } });

    this.clientV3 = createAxiosInstance({
      baseURL        : process.env.SAFEA_API_V3,
      useAccessToken : true,
      customHeaders  : { 'Cache-Control': 'no-cache' } });
  }

  checkToken() {
    return this.client.get('/auth/token/check');
  }

  authenticateSafeALegacyV3() {
    return this.clientV3.get('/auth/sso/legacy/exchange', {
      withCredentials: true
    });
  }
};

export default new SafeAService();
